<div class="flex flex-col gap-3 p-5" *transloco="let t">
   <h2 class="t-page-title text-2xl font-bold">{{ t('disclaimer.title') }}</h2>
   <div class="contents" [innerHTML]="t('disclaimer.text')"></div>
</div>
